
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/skidorter",
      function () {
        return require("private-next-pages/[region]/skidorter.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/skidorter"])
      });
    }
  